/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_CzechInputs */

const en_speechmatics_target_language_czech = /** @type {(inputs: Speechmatics_Target_Language_CzechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czech`)
};

const fr_speechmatics_target_language_czech = /** @type {(inputs: Speechmatics_Target_Language_CzechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tcheque`)
};

const de_speechmatics_target_language_czech = /** @type {(inputs: Speechmatics_Target_Language_CzechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tschechisch`)
};

const it_speechmatics_target_language_czech = /** @type {(inputs: Speechmatics_Target_Language_CzechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ceco`)
};

const ru_speechmatics_target_language_czech = /** @type {(inputs: Speechmatics_Target_Language_CzechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`чешский`)
};

const es_speechmatics_target_language_czech = /** @type {(inputs: Speechmatics_Target_Language_CzechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`checo`)
};

const zh_cn2_speechmatics_target_language_czech = /** @type {(inputs: Speechmatics_Target_Language_CzechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`捷克语`)
};

const ja_speechmatics_target_language_czech = /** @type {(inputs: Speechmatics_Target_Language_CzechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チェコ語`)
};

const hi_speechmatics_target_language_czech = /** @type {(inputs: Speechmatics_Target_Language_CzechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चेक`)
};

const pt_pt2_speechmatics_target_language_czech = /** @type {(inputs: Speechmatics_Target_Language_CzechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tcheco`)
};

/**
* | output |
* | --- |
* | "Czech" |
*
* @param {Speechmatics_Target_Language_CzechInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_czech = /** @type {((inputs?: Speechmatics_Target_Language_CzechInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_CzechInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_czech(inputs)
	if (locale === "de") return de_speechmatics_target_language_czech(inputs)
	if (locale === "it") return it_speechmatics_target_language_czech(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_czech(inputs)
	if (locale === "es") return es_speechmatics_target_language_czech(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_czech(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_czech(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_czech(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_czech(inputs)
	return en_speechmatics_target_language_czech(inputs)
});